const AVATAR_COLORS = [
  '#E53E3E', // red
  '#DD6B20', // orange
  '#D69E2E', // yellow
  '#38A169', // green
  '#319795', // teal
  '#3182CE', // blue
  '#5A67D8', // indigo
  '#805AD5', // purple
  '#D53F8C', // pink
  '#2B6CB0', // dark blue
  '#276749', // dark green
  '#9B2C2C', // dark red
] as const;

/**
 * Deterministic color from a name string.
 * Same name always produces the same color.
 */
export const nameToColor = (name: string): string => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % AVATAR_COLORS.length;
  return AVATAR_COLORS[index];
};
